export default "__VITE_ASSET__n8Nr0ISt__"